/**
 * Search aliases for navigation menu items and groups.
 * Plain string arrays — no ROUTES.* or t() dependencies.
 * Imported directly into tab/group definitions in main-tabs.js so aliases are co-located
 * with the navigation structure they describe.
 */

// Dashboards
export const operationalDashboard = [
  'operational',
  'dashboard',
  'overview',
  'home',
  'summary',
  'op dashboard',
  'main dashboard'
];
export const executiveDashboard = [
  'executive',
  'dashboard',
  'executive summary',
  'c-level',
  'coverage',
  'findings',
  'management'
];
export const riskDashboard = ['risk', 'risk score', 'external risk', 'risk dashboard', 'risk assessment', 'scoring'];
export const threatcloudFeed = [
  'threatcloud',
  'intelligence feed',
  'ioc feed',
  'threat feed',
  'feed dashboard',
  'ioc dashboard',
  'threatcloud intelligence'
];
export const envSummary = ['environment summary', 'env summary', 'mssp', 'multi-tenant', 'mssp view'];

// Alerts & Action Center
export const alerts = [
  'alerts',
  'alert center',
  'alert',
  'notifications',
  'findings',
  'alert management',
  'alert list'
];
export const strategicIntelligence = ['strategic', 'intelligence', 'strategic intelligence', 'strategic alerts'];

// External Attack Surface / ASM
export const asmRevamp = [
  'asm',
  'casm',
  'external attack surface',
  'attack surface',
  'attack surface management',
  'issues',
  'certificates',
  'open ports',
  'domains',
  'ips',
  'assets',
  'digital footprint',
  'vulnerabilities',
  'exposed interfaces',
  'technologies',
  'shadow it',
  'easm',
  'external',
  'surface',
  'discovery',
  'asset'
];

// Supply Chain
export const vendorInventory = [
  'supply chain',
  'vendor',
  'vendors',
  'third party',
  'supply chain intelligence',
  'vendor inventory',
  'vendor risk',
  'third-party risk'
];

// Digital Risk Protection
export const socialMediaFakePages = [
  'social media',
  'fake pages',
  'impersonation',
  'brand abuse',
  'phishing',
  'social media fake pages',
  'brand protection',
  'social media impersonation'
];
export const lookalikeDomain = [
  'lookalike',
  'domain squatting',
  'typosquatting',
  'phishing domains',
  'lookalike domain',
  'domain monitoring',
  'fake domains'
];
export const automatedTakedown = [
  'takedown',
  'removal',
  'automated takedown',
  'takedowns',
  'take down',
  'content removal'
];
export const credentialPurchased = [
  'credential purchase',
  'dark web',
  'credentials purchased',
  'purchased credentials',
  'credential purchases',
  'dark web purchase'
];
export const investigations = [
  'investigations',
  'analyst investigations',
  'investigation',
  'analysis',
  'investigate',
  'research'
];

// Threat Hunting / Intelligence
export const leakedCredentials = [
  'leaked credentials',
  'compromised credentials',
  'data breach',
  'passwords',
  'credential leak',
  'leaked',
  'exposed credentials',
  'breached'
];
export const tiEvents = [
  'ti events',
  'threat intelligence',
  'dark web',
  'raw intelligence',
  'indicators',
  'inbox',
  'darkweb',
  'intelligence events',
  'raw intel'
];
export const intelligenceArchive = [
  'intelligence data lake',
  'data lake',
  'archive',
  'intelligence archive',
  'historical',
  'intel archive',
  'intel data lake'
];
export const forensics = ['forensics', 'forensic analysis', 'forensic', 'investigation', 'forensic investigation'];
export const filesAnalyzer = [
  'file analyzer',
  'threat emulation',
  'sandbox',
  'malware analysis',
  'file analysis',
  'threats emulation',
  'files'
];

// Threat Knowledgebase
export const threatLandscape = [
  'threat landscape',
  'workbench',
  'cve',
  'vulnerabilities',
  'threats',
  'threat overview',
  'threat map',
  'landscape',
  'threat intel',
  'threat dashboard'
];
export const incidents = ['incidents', 'cyber incidents', 'attacks', 'cyber attacks', 'incident', 'security incidents'];
export const threatActors = [
  'threat actors',
  'apt',
  'threat groups',
  'hackers',
  'adversaries',
  'actor',
  'threat actor',
  'groups',
  'nation state',
  'cve',
  'ioc'
];
export const campaigns = ['campaigns', 'threat campaigns', 'attack campaigns', 'campaign', 'cyber campaigns'];
export const cveNg = ['cve ng', 'cve next gen', 'vulnerabilities', 'vulnerability'];
export const iocExplorer = ['ioc', 'ioc explorer', 'ioc management', 'indicators', 'indicators of compromise'];
export const threatReadinessDashboard = [
  'threat readiness',
  'readiness',
  'threat readiness dashboard',
  'readiness dashboard'
];
export const malwareKb = [
  'malware',
  'malware intelligence',
  'malware knowledge base',
  'malware kb',
  'malware intel',
  'malicious software',
  'ransomware',
  'trojan',
  'cve',
  'ioc'
];
export const cve = [
  'cve',
  'vulnerabilities',
  'vulnerability',
  'common vulnerabilities',
  'exploit',
  'exploits',
  'cves',
  'patch',
  'zero day'
];
export const reports = ['reports', 'intelligence reports', 'collaboration', 'report', 'analyst reports'];
export const cyberintNews = [
  'bulletin board',
  'news',
  'cyberint news',
  'security news',
  'cyber news',
  'bulletin',
  'announcements'
];
export const newsTicker = ['security news', 'news ticker', 'cyber news', 'news feed', 'news', 'ticker'];

// Knowledge Hub (EM)
// subPage keywords (threat actors, cve, malware, ioc) are matched via the subPages
// of this tab in navigation search — no need to duplicate them here.
export const knowledgeHub = [
  'knowledge hub',
  'knowledge base',
  'threat intelligence',
  'threat kb',
  'knowledgebase',
  'knowledge'
];
// subPage keywords (incidents, campaigns, cyber news, attacks) come from the
// subPages of this tab in navigation search — kept only group-unique aliases here.
export const cyberNewsAttacks = ['news and attacks'];

// Account & Management
export const customerMgmt = [
  'customer management',
  'tenants',
  'tenant management',
  'customers',
  'manage tenants',
  'tenant'
];
export const myAccount = [
  'my account',
  'settings',
  'account settings',
  'preferences',
  'configuration',
  'profile',
  // User & access management
  'user management',
  'user',
  'users',
  'user login events',
  'login events',
  'audit log',
  'audit',
  'sso',
  'sso configuration',
  'single sign on',
  // License & assets
  'license management',
  'license',
  'assets management',
  'assets',
  'asset',
  // Branding
  'brands configuration',
  'brand',
  'brands',
  'brand configuration',
  // Intelligence & alerts configuration
  'targeted alerts',
  'strategic intelligence',
  'filtered view',
  'environment insights',
  // Security configuration
  'asm configuration',
  'phishing beacon',
  'phishing beacon configuration',
  'phishing beacon tester',
  'phishing',
  'beacon'
];

// TEM tabs
export const temDashboard = ['tem dashboard', 'internal exposure', 'exposure overview', 'dashboard'];
export const temMap = ['live attack map', 'organization attack map', 'map', 'live map'];
export const temIndicators = [
  'ioc dissemination',
  'dissemination',
  'ioc management',
  'indicators of compromise',
  'ioc',
  'indicators'
];
export const temRemediation = ['vulnerability prioritization', 'remediation', 'vulnerability remediation', 'patching'];
export const temAssets = ['security controls', 'assets', 'controls'];
export const temInsights = ['security insights', 'insights', 'tem insights'];
export const temSettings = ['tem settings', 'settings', 'tem configuration'];
export const temIntegrations = ['integrations', 'integrations', 'erm integrations', 'connections'];

export const cyclops = ['cyclops', 'caasm'];

// Menu group keywords (for collapsible groups in OLD_MENU / EM_MENU that have no tab.type).
// Added as a `keywords` field directly on the group object in main-tabs.js.
export const digitalRiskProtection = [
  'drp',
  'digital risk',
  'digital risk protection',
  'brand protection',
  'risk protection'
];
export const threatHunting = ['threat hunting', 'hunting', 'threat hunt', 'intel hunting'];
export const threatKb = [
  'threat knowledgebase',
  'knowledgebase',
  'kb',
  'threat knowledge',
  'threat kb',
  'knowledge base'
];
export const dashboards = ['dashboards', 'dashboard', 'reporting', 'analytics'];
export const actionCenter = ['action center', 'actions', 'response'];
export const exposure = ['exposure', 'attack surface', 'vulnerability'];
export const remediations = ['remediations', 'remediation', 'takedown', 'response'];
export const cyberThreatIntelligence = [
  'cti',
  'cyber threat intelligence',
  'threat intelligence',
  'intelligence',
  'threat intel'
];
export const targetedIntelligence = ['targeted intelligence', 'targeted', 'specific intelligence'];
export const threatInvestigation = ['threat investigation', 'investigation', 'forensics', 'deep dive'];
export const reportsDashboards = ['reports', 'dashboards', 'analytics', 'reporting'];
export const integrationsGroup = ['integrations', 'connections', 'plugins'];
export const blast = ['blast'];
export const caasmConfigurationGroup = ['caasm', 'configuration', 'preferences'];
export const settingsGroup = ['settings', 'configuration', 'preferences'];
